var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"photo-icon",attrs:{"src":_vm.imgUrl,"width":_vm.size,"height":_vm.size,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }